import { OperationActions, OperationTypes, ISubirArchivos } from "../../consts/OperationTypes";

export const desencriptarPrestador = (payload : string) : OperationActions => ({
    type: OperationTypes.START,
    payload
});

export const subirArchivos = (payload : ISubirArchivos) : OperationActions => ({
    type: OperationTypes.CARGAR_ARCHIVOS_START,
    payload
});